"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Title = exports.SliderContainer = exports.LegendContainer = exports.Header = exports.CloseButton = exports.ApplyButton = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const colors_1 = require("../../../../assets/styles/colors");
const Button_style_1 = require("../../../atoms/Button/Button.style");
const Typography_1 = require("../../../atoms/Typography");
const LegendContainer = styled_components_1.default.div `
  display: grid;
  position: fixed;
  grid-template-rows: auto 1fr auto;
  gap: 2rem;
  bottom: 0;
  flex-direction: column;
  align-items: center;
  width: 100%;
  background-color: white;
  padding: 1.6rem;
  z-index: 2;
`;
exports.LegendContainer = LegendContainer;
const Header = styled_components_1.default.div `
  display: grid;
  justify-content: space-between;
  grid-template-columns: auto 1fr;
  gap: 1.6rem;
  width: 100%;
  min-height: 2.4rem;
  height: fit-content;
  align-items: center;
`;
exports.Header = Header;
const CloseButton = styled_components_1.default.button `
  margin: 0;
  padding: 0;
  border: 0;
  background: none;
  position: relative;
  width: 1.7rem;
  height: 1.7rem;

  &:before,
  &:after {
    content: "";
    position: absolute;
    top: (1.7rem - 0.1rem) / 2;
    left: 0;
    right: 0;
    height: 0.15rem;
    background: ${colors_1.gray400};
  }

  &:before {
    transform: rotate(45deg);
  }

  &:after {
    transform: rotate(-45deg);
  }

  span {
    display: block;
  }
`;
exports.CloseButton = CloseButton;
const Title = (0, styled_components_1.default)(Typography_1.H3) `
  display: inline;
  font-size: 1.6rem;
  line-height: 1.92rem;
`;
exports.Title = Title;
const SliderContainer = styled_components_1.default.div `
  display: grid;
  gap: 1.6rem;
  grid-template-rows: auto 1fr;
  width: 100%;
`;
exports.SliderContainer = SliderContainer;
const ApplyButton = (0, styled_components_1.default)(Button_style_1.Button) `
  background-color: ${colors_1.white};
  color: ${colors_1.acBlueDark};
  text-transform: uppercase;
  text-size: 1.4rem;
  border-radius: 0.5rem;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 3.6rem;
  border: 2px solid ${colors_1.blue};
`;
exports.ApplyButton = ApplyButton;
